// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__iICw7","sound":"Footer_sound__LI7AP","homefoto":"Footer_homefoto__IATAG","source":"Footer_source__LSQyK"};